/* eslint-disable */
import axios from "axios";

/**
 * Catch all the data from the last tweet
 * @returns
 */
const ajaxRequest = async (component) => {
  const liveConfComponent = document.querySelector(component);
  const action = liveConfComponent.getAttribute("data-action");
  const id = liveConfComponent.getAttribute("data-id");

  try {
    const response = await axios.get(
      `${location.origin}/ajax.php?action=${action}&id=${id}`
    );
    return response.data.data;
  } catch (error) {
    console.error(error);
  }
};

export default ajaxRequest;
